import base64url from 'base64url';

export function decode(jwt) {
  let [ header, payload, sign ] = jwt.split('.');
  header = JSON.parse(base64url.decode(header));
  payload = JSON.parse(base64url.decode(payload));
  sign = base64url.toBuffer(sign);
  return { header, payload, sign };
}
